import React from "react";
import "../Navigation/css/NavBar.scss";

export default function KnownIssues() {
    return (
        <div>
            Known Issues
        </div>
    )
}